import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { X, Cookie } from "@phosphor-icons/react";

const KEY = "soulstar_cookies_choice";  // "accepted" | "rejected"

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        // Delay a beat so it doesn't compete with page-entry animation
        const t = setTimeout(() => {
            if (!localStorage.getItem(KEY)) setVisible(true);
        }, 900);
        return () => clearTimeout(t);
    }, []);

    const choose = (choice) => {
        localStorage.setItem(KEY, choice);
        localStorage.setItem(KEY + "_at", new Date().toISOString());
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 80, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 80, opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeOut" }}
                    className="fixed bottom-4 inset-x-4 sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-md z-[100]"
                    data-testid="cookie-banner"
                >
                    <div className="glass-gold p-4 sm:p-5 rounded-2xl shadow-2xl relative">
                        <button
                            onClick={() => choose("rejected")}
                            className="absolute top-2 right-2 w-7 h-7 rounded-full text-muted hover:text-gold flex items-center justify-center"
                            aria-label="Close"
                            data-testid="cookie-banner-close"
                        >
                            <X size={12} />
                        </button>
                        <div className="flex items-start gap-3 pr-6">
                            <Cookie size={20} weight="duotone" className="text-gold flex-shrink-0 mt-0.5" />
                            <div>
                                <p className="font-serif text-lg leading-tight">A cosmic cookie note</p>
                                <p className="text-xs text-muted mt-2 leading-relaxed">
                                    We use strictly necessary cookies to keep you signed in and remember
                                    small preferences. No ad-tracking. See our{" "}
                                    <Link to="/privacy" className="text-gold hover:underline" data-testid="cookie-banner-privacy">
                                        Privacy Policy
                                    </Link>
                                    .
                                </p>
                                <div className="flex gap-2 mt-4">
                                    <button
                                        onClick={() => choose("accepted")}
                                        className="btn-gold-solid text-xs px-4 py-2"
                                        data-testid="cookie-banner-accept"
                                    >
                                        Accept
                                    </button>
                                    <button
                                        onClick={() => choose("rejected")}
                                        className="text-xs label-tracking text-muted hover:text-gold px-3 py-2 rounded-full border border-white/10 transition-colors"
                                        data-testid="cookie-banner-reject"
                                    >
                                        Only necessary
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
